import { useState, type ReactNode } from "react";
import { useIsNavigationTreeFocused } from "#use-is-navigation-tree-focused";

/**
 * NativeTabs constructs every scene eagerly. Keep its native tab chrome, but mount a catalog's
 * providers, redirects and rows only when its route first becomes visible. After that visit the
 * subtree stays mounted, preserving filters, scroll and navigation history across tab switches.
 * Keep lightweight controls outside this gate and supply a data-free skeleton: native navigation
 * can expose a scene before React receives its focus event.
 */
export function LazyBrowseTabContent({
  children,
  fallback = null,
}: {
  children: ReactNode;
  fallback?: ReactNode;
}) {
  const focused = useIsNavigationTreeFocused();
  const [hasBeenFocused, setHasBeenFocused] = useState(focused);
  if (focused && !hasBeenFocused) {
    // Latch during this render so a native freeze immediately after the visit cannot lose it.
    setHasBeenFocused(true);
  }
  return focused || hasBeenFocused ? children : fallback;
}
